import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import * as S from './UpgradeSubscriptionButton.styled';
export const UpgradeSubscriptionButton = ({ fullWidth = false, label = 'Upgrade to Pro', type = 'button', size = 'small', source, onClick, }) => {
    useEffect(() => {
        TagManager.dataLayer({
            dataLayer: { event: 'upgrade_button_displayed', source },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(S.Container, { "$fullWidth": fullWidth, size: size, type: type, onClick: onClick }, label));
};
